import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { HttpService } from 'ngx-libs-http';
import { Faucets } from '../api/main/faucets';
import { Markets } from '../api/main/markets';
import { Accounts } from '../api/main/accounts';
import { Ips } from '../api/main/ips';
import { PointLeaderboards } from '../api/main/point-leaderboards';
import { Announcements } from '../api/main/announcements';
import { TradingVaults } from '../api/main/trading-vaults';
import { Beta } from '../api/main/beta';

@Injectable({
  providedIn: 'root'
})
export class MainService {
  httpClient: HttpClient;
  // unauthorized: Observable<any>;
  markets: Markets;
  accounts: Accounts;
  faucets: Faucets;
  ips: Ips;
  pointLeaderboards: PointLeaderboards;
  announcements: Announcements;
  tradingVaults: TradingVaults;
  beta: Beta;

  constructor(private httpService: HttpService) {
    this.httpClient = this.httpService.get('main');
    // this.unauthorized = this.httpService.unauthorized('main');
    this.markets = new Markets(this.httpClient);
    this.accounts = new Accounts(this.httpClient);
    this.faucets = new Faucets(this.httpClient);
    this.ips = new Ips(this.httpClient);
    this.pointLeaderboards = new PointLeaderboards(this.httpClient);
    this.announcements = new Announcements(this.httpClient);
    this.tradingVaults = new TradingVaults(this.httpClient);
    this.beta = new Beta(this.httpClient);
  }
}
